export function resolvePosition(position, imgLeft, imgTop, imgWidth, imgHeight) {
  const thirdW = imgWidth / 3;
  switch (position) {
    case 'top-left':
      return { left: imgLeft, top: imgTop + 28, width: thirdW };
    case 'top-center':
      return { left: imgLeft + thirdW, top: imgTop + 28, width: thirdW };
    case 'top-right':
      return { left: imgLeft + thirdW * 2, top: imgTop + 28, width: thirdW };
    case 'bottom-title':
      return { left: imgLeft, top: imgTop + imgHeight * 0.70 - 25, width: imgWidth };
    case 'bottom-subtitle':
      return { left: imgLeft, top: imgTop + imgHeight * 0.82, width: imgWidth };
    case 'bottom-cinemas':
      return { left: imgLeft, top: imgTop + imgHeight * 0.89, width: imgWidth };
    case 'bottom-directed':
      return { left: imgLeft, top: imgTop + imgHeight * 0.94, width: imgWidth };
    case 'mission-tr-1':
      return { left: imgLeft + imgWidth * 0.025, top: imgTop + 28, width: imgWidth * 0.95 };
    case 'mission-tr-2':
      return { left: imgLeft + imgWidth * 0.025, top: imgTop + 120, width: imgWidth * 0.95 };
    case 'mission-tr-3':
      return { left: imgLeft + imgWidth * 0.025, top: imgTop + 175, width: imgWidth * 0.95 };
    case 'mission-tr-4':
      return { left: imgLeft + imgWidth * 0.025, top: imgTop + 230, width: imgWidth * 0.95 };
    case 'mission-bl':
      return { left: imgLeft + 20, top: imgTop + imgHeight * 0.82, width: imgWidth * 0.5 };
    default:
      return { left: imgLeft, top: imgTop, width: imgWidth };
  }
}
